import { render, staticRenderFns } from "./ResellerLayout.vue?vue&type=template&id=b7d59a6a&"
import script from "./ResellerLayout.vue?vue&type=script&lang=js&"
export * from "./ResellerLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports